'use strict';

angular.module('url-title.fltr', [])

.filter('urlTitle', [function() {
  return function(value) {
    return value.replace(/\s/g, '-').toLowerCase();
  };
}]);
